import { z } from 'zod';

export const updateUserSettingsSchema = z.object({
  // Resolves to `{{planner_name}}`, so this is the name a vendor reads above
  // the business in every sign-off. Trimmed and non-empty or it is not a name —
  // a blank one signs the mail with nothing at all.
  name: z.string().trim().min(1).max(255).optional(),
  // The plain-text twin is derived server-side from the HTML, so this stays
  // for the pre-editor path and for clients that only have text.
  emailSignature: z.string().max(2000).nullable().optional(),
  // 100KB: a two-column table with inline styles on every cell runs to a few
  // kilobytes, and a planner who pastes a decade of accumulated Gmail markup
  // should hit a real error rather than a silent truncation.
  emailSignatureHtml: z.string().max(100_000).nullable().optional(),
  businessName: z.string().max(255).nullable().optional(),
  timezone: z.string().max(64).optional(),
  /** Days of silence before an inquiry auto-moves to `no_response`. PRD §13
   *  flags 10 as an assumption worth revisiting per category. */
  noResponseDays: z.number().int().min(1).max(90).optional(),
});

export type UpdateUserSettingsInput = z.infer<typeof updateUserSettingsSchema>;
